import { memo, useEffect } from "react";

export interface VideoShortcutsProps {
  onRequestDecreaseSpeed?: () => void;
  onRequestFullscreen?: () => void;
  onRequestGoBackward?: () => void;
  onRequestGoForward?: () => void;
  onRequestIncreaseSpeed?: () => void;
  onRequestPlayToggle?: () => void;
}

export const VideoShortcuts = memo(function VideoShortcuts({
  onRequestDecreaseSpeed,
  onRequestFullscreen,
  onRequestGoBackward,
  onRequestGoForward,
  onRequestIncreaseSpeed,
  onRequestPlayToggle,
}: VideoShortcutsProps) {
  useEffect(() => {
    function handleKeydown(e: KeyboardEventInit) {
      if (!document.activeElement?.classList.contains("Video")) {
        return;
      }

      if (e.shiftKey) {
        switch (e.key) {
          case "ArrowRight":
            onRequestIncreaseSpeed?.();
            return;
          case "ArrowLeft":
            onRequestDecreaseSpeed?.();
            return;
          default:
            return;
        }
      }

      switch (e.key) {
        case " ":
        case "k":
          onRequestPlayToggle?.();
          return;
        case "ArrowLeft":
        case "j":
          onRequestGoBackward?.();
          return;
        case "ArrowRight":
        case "l":
          onRequestGoForward?.();
          return;
        case "f":
          onRequestFullscreen?.();
          return;
        default:
          return;
      }
    }

    document.addEventListener("keydown", handleKeydown);

    return () => {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, [
    onRequestPlayToggle,
    onRequestGoBackward,
    onRequestGoForward,
    onRequestFullscreen,
    onRequestIncreaseSpeed,
    onRequestDecreaseSpeed,
  ]);

  return null;
});
